import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";

const isStatusOption = [
  { id: 1, label: "Yes", value: true },
  { id: 0, label: "No", value: false },
];

const BankForm = () => {
  const {
    control,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();
  return (
    <div className="form-row row">
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="organisationId"
          type="text"
          placeholder="Organisation Id"
          className={`form-control ${errors.organisationId ? "is-invalid" : ""}`}
          label="Organisation Id"
          labelClassName="form-label"
          required={true}
          requiredMessage="Organisation Id is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="bankCode"
          type="text"
          placeholder="Bank Code"
          className={`form-control ${errors.bankCode ? "is-invalid" : ""}`}
          label="Bank Code"
          labelClassName="form-label"
          required={true}
          requiredMessage="Bank Code is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="bankShortCode"
          type="text"
          placeholder="Bank Short Code"
          className={`form-control ${errors.bankShortCode ? "is-invalid" : ""}`}
          label="Bank Short Code"
          labelClassName="form-label"
          required={true}
          requiredMessage="Bank Short Code is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="bankName"
          type="text"
          placeholder="Bank Name"
          className={`form-control ${errors.bankName ? "is-invalid" : ""}`}
          label="Bank Name"
          labelClassName="form-label"
          required={true}
          requiredMessage="Bank Name is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="accountNumber"
          type="text"
          placeholder="Account Number"
          className={`form-control ${errors.accountNumber ? "is-invalid" : ""}`}
          label="Account Number"
          labelClassName="form-label"
          required={true}
          requiredMessage="Account Number is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="swiftCode"
          type="text"
          placeholder="Swift Code"
          className={`form-control ${errors.swiftCode ? "is-invalid" : ""}`}
          label="Swift Code"
          labelClassName="form-label"
          required={false}
          requiredMessage="Swift Code is required"
          defaultValue=""
        />
      </div>
      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="companyUEN"
          type="text"
          placeholder="Company UEN"
          className={`form-control ${errors.companyUEN ? "is-invalid" : ""}`}
          label="Company UEN"
          labelClassName="form-label"
          required={false}
          requiredMessage="Company UEN is required"
          defaultValue=""
        />
      </div>

      <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name="isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
            errors.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div>
    </div>
  );
};

export default BankForm;
